<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 98%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.amcbsUser" style="width: 130px;" size="mini" placeholder="使用人"
                        clearable></el-input>
                    <el-input v-model="formDatas.amcbsDepartment" style="width: 130px;" size="mini" placeholder="部门"
                        clearable></el-input>
                    <el-date-picker v-model="formDatas.amcbsYear" type="year" value-format="yyyy" placeholder="所属年"
                        style="width: 140px;" size="mini">
                    </el-date-picker>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <el-button type="success" size="mini" style="margin-left: 20px"
                        @click="exportExcel">执行计算</el-button>
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="keyindex" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>

        </div>
    </div>
</template>

<script>

import {
    getAjMobileCardBillStatisticsList, updateAddressBook, getAjUserDetails, exportAddressBook, exportAddressBookRecord, updateAjMobileCardBillStatisticsAction
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            dateUpdata: '',
            TypeId: 0,
            auPostManage: '',
            auDepartmentArr: [],
            dbtrue: false,
            workingWithRecordsShow: false,
            userMonth: '',
            aocName: '',
            IsSerch: false,
            // 名族
            auNationArr: [],

            Related: false,
            afcTypearr: [],
            aacTypearr: [],
            aaTypearr: [],
            amTypearr: [],
            IsSerch: false,
            dialog: false,
            edit: false,
            form: {

            },
            DetailArr: [],
            IsDetail: false,
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                // {
                //     field: "",
                //     key: "checkbox",
                //     type: "checkbox",
                //     fixed: 'left',
                //     title: "",
                //     width: 50,
                //     align: "center",
                // },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    fixed: 'left',
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "amcbsYear",
                    key: "amcbsYear",
                    title: "所属年",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "amcbsUser",
                    key: "amcbsUser",
                    title: "使用人",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "amcbsDepartment",
                    key: "amcbsDepartment",
                    title: "部门",
                    align: "center",
                    edit: false,
                    width: 160,
                },
                {
                    field: "monthJanuary",
                    key: "monthJanuary",
                    title: "1月金额",
                    align: "center",
                    edit: false,
                    width: 80,
                },
                {
                    field: "monthFebruary",
                    key: "monthFebruary",
                    title: "2月金额",
                    align: "center",
                    edit: false,
                    width: 80,
                },
                {
                    field: "monthMarch",
                    key: "monthMarch",
                    title: "3月金额",
                    align: "center",
                    edit: false,
                    width: 80,
                },
                {
                    field: "monthApril",
                    key: "monthApril",
                    title: "4月金额",
                    align: "center",
                    edit: false,
                    width: 80,
                },
                {
                    field: "monthMay",
                    key: "monthMay",
                    title: "5月金额",
                    align: "center",
                    edit: false,
                    width: 80,
                },
                {
                    field: "monthJune",
                    key: "monthJune",
                    title: "6月金额",
                    align: "center",
                    edit: false,
                    width: 80,
                },
                {
                    field: "monthJuly",
                    key: "monthJuly",
                    title: "7月金额",
                    align: "center",
                    edit: false,
                    width: 80,
                },
                {
                    field: "monthAugust",
                    key: "monthAugust",
                    title: "8月金额",
                    align: "center",
                    edit: false,
                    width: 80,
                },
                {
                    field: "monthSeptember",
                    key: "monthSeptember",
                    title: "9月金额",
                    align: "center",
                    edit: false,
                    width: 80,
                },
                {
                    field: "monthOctober",
                    key: "monthOctober",
                    title: "10月金额",
                    align: "center",
                    edit: false,
                    width: 80,
                },
                {
                    field: "monthNovember",
                    key: "monthNovember",
                    title: "11月金额",
                    align: "center",
                    edit: false,
                    width: 80,
                },
                {
                    field: "monthDecember",
                    key: "monthDecember",
                    title: "12月金额",
                    align: "center",
                    edit: false,
                    width: 80,
                },
                {
                    field: "createtime",
                    key: "createtime",
                    title: "创建时间",
                    align: "center",
                    edit: false,
                    width: 160,
                }
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                auBelong: '',
                auDepartment: '',
                amcDes: '',
                auName: '',
                aocName: '',
                auContactMine: '',
                afOwnerType: '',
                amcNumber: '',
                amcNumberCornet: '',
                auDateEntryStart: '',
                auDateEntryEnd: '',
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;

        this.getList();

    },
    mounted() {

    },
    methods: {
        exportExcel() {
            this.$confirm("此操作将执行计算, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.openLoading()
                    updateAjMobileCardBillStatisticsAction(this.formDatas).then(res => {
                        this.loadings.close()
                        this.$message({
                            type: "success",
                            message: "计算成功!",
                        });
                        this.partserch()
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        sureDate() {
            this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    var formdata = this.dateUpdata[0] || this.dateUpdata;
                    if (this.dateUpdata.length > 1) {
                        formdata = this.dateUpdata[this.dateUpdata.length - 1]
                    }
                    let formData = new FormData();
                    formData.append(this.dateKeys, formdata);
                    console.log(this.auPostManage);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.auId = this.keysId
                    jsonObj.auPostManage = this.auPostManage
                    updateAddressBook(jsonObj).then(res => {
                        if (res.status == 200) {

                            this.dbtrue = false;
                            this.auPostManage = '';
                            this.getList()
                            this.$message({
                                type: "success",
                                message: "编辑成功!",
                            });
                        }

                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        getdbtrue(val, key, index, id, typeid, Arr, row) {
            console.log("双击", val, key, index);
            this.dbtrue = true;
            this.dateUpdata = val;
            this.dateKeys = key;
            this.dateIndexs = index;
            this.keysId = id;
            this.TypeId = typeid;
            this.auPostManage = row.auPostManage
            this.EditArr = Arr

        },
        workingWithRecordsClick() {
            this.$confirm("此操作将导出该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const s = {
                        userMonth: this.userMonth,
                        aocName: this.aocName
                    }
                    this.openLoading()
                    exportAddressBookRecord(s).then(res => {
                        this.openLoading()
                        this.loadings.close()
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: "导出成功!",
                        });
                        this.workingWithRecordsShow = false;
                    })
                }).catch(() => {
                    this.$message({
                        type: "success",
                        message: "已取消",
                    });
                })
        },
        workingWithRecordsClose() {
            this.workingWithRecordsShow = false;
        },
        SerchMore() {
            this.IsSerch = true;
        },
        closeSizer() {
            this.formDatas = {
                auBelong: '',
                auDepartment: '',
                auName: '',
                aocName: '',
                auContactMine: '',
                afOwnerType: '',
                amcNumber: '',
                amcNumberCornet: '',
                auDateEntryStart: '',
                auDateEntryEnd: '',
                currentPage: 1,
                pageSize: 10,
            };
            this.IsSerch = false;
            this.partserch()
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Out(command) {
            console.log(command);
            if (!command) {
                console.log('开始导出', this.selectedRowKeysCollection)
                // this.openLoading()
                // exportAddressBook({ auIds: this.selectedRowKeysCollection.toString() }).then(res => {
                //     if (res.status == 200) {
                //         this.loadings.close()
                //         window.location.href = res.data;
                //         this.$message({
                //             type: "success",
                //             message: '导出成功',
                //         });
                //         this.checkboxOption.selectedRowKeys = this.selectedRowKeysCollection = []

                //     }
                // })
                console.log(command);
                this.openLoading()
                exportAddressBook({ exportType: 1, ...this.formDatas }).then(res => {
                    if (res.status == 200) {
                        this.loadings.close()
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: '导出成功',
                        });


                    }
                })
            } else if (command == '1') {
                console.log(command);
                this.openLoading()
                exportAddressBook({ exportType: 1, ...this.formDatas }).then(res => {
                    if (res.status == 200) {
                        this.loadings.close()
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: '导出成功',
                        });


                    }
                })
            } else if (command == '2') {
                this.userMonth = '';
                this.aocName = '';
                this.workingWithRecordsShow = true;
            }
        },

        getDetail(id) {
            getAjUserDetails({ auId: id }).then(res => {
                this.DetailArr = res.data;
                this.IsDetail = true;
                console.log(this.DetailArr);
            })
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.auId = row.auId
                    console.log(jsonObj);
                    updateAddressBook(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys() {
            console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item.auId) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item.auId);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys) {
            console.log(isSelected, selectedRowKeys);
            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item.auId) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item.auId), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected) {
            const rowKey = row.auId;

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjMobileCardBillStatisticsList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //     type: "success",
                //     message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjMobileCardBillStatisticsList(this.formDatas).then((res) => {
                const resData = res.data;
                resData.forEach((item, index) => {
                    item.keyindex = index;
                })
                this.tableData = resData;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //     type: "success",
                //     message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAjMobileCardBillStatisticsList(this.formDatas).then((res) => {
                const resData = res.data;
                resData.forEach((item, index) => {
                    item.keyindex = index;
                })
                this.tableData = resData;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>